import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class Atol3PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.ATOL3;
}

export default Atol3PoiTileEntity;
